<template>
  <ul class="pagination">
    <li v-if="showFist" class="pagination-item">
      <button type="button" :disabled="isInFirstPage" aria-label="Go to first page" @click="onClickFirstPage">
        First
      </button>
    </li>

    <li v-if="showPrev" class="pagination-item">
      <button type="button" :disabled="isInFirstPage" aria-label="Go to previous page" @click="onClickPreviousPage">
        Prev
      </button>
    </li>
    <li v-for="page in pages" :key="page.name" class="pagination-item">
      <button
        type="button"
        :disabled="page.isDisabled"
        :class="{active: isPageActive(page.name)}"
        :aria-label="`Go to page number ${page.name}`"
        @click="onClickPage(page.name)"
      >
        {{ page.name }}
      </button>
    </li>
    <li v-if="showNext" class="pagination-item">
      <button type="button" :disabled="isInLastPage" aria-label="Go to next page" @click="onClickNextPage">Next</button>
    </li>

    <li v-if="showLast" class="pagination-item">
      <button type="button" :disabled="isInLastPage" aria-label="Go to last page" @click="onClickLastPage">Last</button>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "PaginationComponent",
    props: {
      maxVisibleButtons: {
        type: Number,
        required: false,
        default: 3
      },
      total: {
        type: Number,
        required: true
      },
      perPage: {
        type: Number,
        required: true
      },
      currentPage: {
        type: Number,
        required: true
      },
      showNext: {
        type: Boolean,
        required: false,
        default: false
      },
      showPrev: {
        type: Boolean,
        required: false,
        default: false
      },
      showFist: {
        type: Boolean,
        required: false,
        default: false
      },
      showLast: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      maxVisibleButtonsComputed() {
        if (this.maxVisibleButtons > this.totalPages) {
          return this.totalPages
        }
        return this.maxVisibleButtons
      },
      startPage() {
        if (this.currentPage === 1) {
          return 1
        }
        if (this.maxVisibleButtonsComputed === this.totalPages) {
          return 1
        }
        if (this.currentPage === this.totalPages) {
          return this.totalPages - this.maxVisibleButtonsComputed + 1
        }
        return this.currentPage - 1
      },
      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtonsComputed - 1, this.totalPages)
      },
      pages() {
        const range = []
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          })
        }
        return range
      },
      isInFirstPage() {
        return this.currentPage === 1
      },
      isInLastPage() {
        return this.currentPage === this.totalPages
      },
      totalPages() {
        return Math.ceil(this.total / this.perPage)
      }
    },
    methods: {
      onClickFirstPage() {
        this.$emit("pagechanged", 1)
      },
      onClickPreviousPage() {
        this.$emit("pagechanged", this.currentPage - 1)
      },
      onClickPage(page) {
        this.$emit("pagechanged", page)
      },
      onClickNextPage() {
        this.$emit("pagechanged", this.currentPage + 1)
      },
      onClickLastPage() {
        this.$emit("pagechanged", this.totalPages)
      },
      isPageActive(page) {
        return this.currentPage === page
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/settings/_color.scss";

  ul {
    padding: 10px 0;
  }
  .pagination {
    list-style-type: none;
    margin-top: 10px;
    border-top: 1px solid #707070;
    button {
      color: black;
      margin-right: 20px;
      background: none;
      border: none;
      cursor: pointer;
      &.active {
        font-weight: 700;
        border-bottom: 2px solid $color-primary;
        color: black !important;
      }
      &:disabled {
        color: #707070;
        cursor: not-allowed;
      }
    }
  }

  .pagination-item {
    display: inline-block;
  }
</style>
